module.exports = __webpack_public_path__ + "static/CreateNewApplication-9bb79fbc8a5fc8b684b415e22ec13342.png";